export default __webpack_public_path__ + "static/media/bedroom.ff777e62.jpg";